import React, { useMemo, useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

import styles from "./styles.scss";

// Define a custom style for DataTable
const customStyles = {
    rows: {
        style: {
            left: 0,
            minHeight: "2rem", // Set the minimum height for rows
            transition: `backgroundColor ${styles.backgroundAnimationSpeed} ease-in-out`,

            '&:hover': {
                backgroundColor: styles.ccLightGrey,
                cursor: "pointer",
            },
        },
    },
    headCells: {
        style: {
            fontSize: '16px',
            fontWeight: 'bold',
            paddingLeft: '8px', // Define the padding for header cells
            paddingRight: '8px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    cells: {
        style: {
            fontSize: '14px',
            paddingLeft: '8px', // Define the padding for cells
            paddingRight: '8px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
};

const FilterComponent = ({ filterText, onFilter }) => (
    <input
        id="search"
        type="text"
        placeholder="Filter By Tag name"
        aria-label="Search Input"
        value={filterText}
        onChange={onFilter}
    />
);


const TableComponent = (params) => {
    const {
        columns,
        tableData,
        rowClickFunction,
        filterParam,
        keyField,
        includeIndexColumn = true, // New prop to control index column
        showSubHeader = true, // New prop to control subheader visibility
    } = params;

    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const [filteredItems, setFilteredItems] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [displayColumns, setDisplayColumns] = useState(columns); // New state to control display columns

    const updatedColumns = useMemo(() => [
        {
            name: '',
            cell: (row, index) => ((currentPage - 1) * perPage) + index + 1,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '4%',
            style: {
                justifyContent: "left",
            },
        },
        ...columns,
    ], [currentPage, perPage, columns]);

    // Update the display columns based on the includeIndexColumn prop
    useEffect(() => { setDisplayColumns(includeIndexColumn ? updatedColumns : columns); }, [includeIndexColumn, updatedColumns, columns]);

    useEffect(() => {
        if (filterText !== "") {
            setFilteredItems(tableData.filter(
                item => item[filterParam] && item[filterParam].toLowerCase().includes(filterText.toLowerCase()),
            ));
        }
        else {
            setFilteredItems(tableData);
        }
    }, [tableData, filterText]);

    
    // const subHeaderComponentMemo = useMemo(() => {
    //     const handleClear = () => {
    //         if (filterText) {
    //             setResetPaginationToggle(!resetPaginationToggle);
    //             setFilterText('');
    //         }
    //     };

    //     return (
    //         <FilterComponent
    //             onFilter={e => setFilterText(e.target.value)}
    //             onClear={handleClear}
    //             filterText={filterText}
    //         />
    //     );
    // }, [filterText, resetPaginationToggle]);

    return (
        <DataTable
            columns={displayColumns}
            data={filteredItems}
            keyField={keyField}
            customStyles={customStyles}
            responsive
            pagination
            subHeader={showSubHeader}
            // subHeaderComponent={subHeaderComponentMemo}
            persistTableHead
            selectableRows={false}
            // subHeaderComponent={subHeaderComponentMemo}
            onRowClicked={(row, index) => rowClickFunction(row)}
            onChangePage={page => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage, page) => {
                setPerPage(newPerPage);
                setCurrentPage(page);
            }}
        />
    );
};

export default TableComponent;